import { HttpClient } from '@angular/common/http'
import { inject, Injectable, signal } from '@angular/core'
import { Observable } from 'rxjs'
import { tap } from 'rxjs/operators'

import { environment } from '../../../environments/environment'
import { ApiResponse } from '../types/response.type'
import { DomainService } from './domain.service'

const API_URL = environment.apiUrl

@Injectable({
	providedIn: 'root',
})
export class WhiteLabelService {
	http = inject(HttpClient)

	domainService = inject(DomainService)

	isSelfRegistrationEnabled = signal<boolean>(false)

	fetchPermissions(): Observable<ApiResponse<{ SELF_REGISTER_ALLOWED: boolean }[]>> {
		return this.http.get<ApiResponse<{ SELF_REGISTER_ALLOWED: boolean }[]>>(`${API_URL}/api/white_label/get_permission/${this.domainService.domain}`).pipe(
			tap((response) => {
				if (response?.status === 'ok') {
					const selfRegistrationEnabled = response?.result?.[0]?.SELF_REGISTER_ALLOWED ?? false
					this.isSelfRegistrationEnabled.set(selfRegistrationEnabled)
				}
			}),
		)
	}
}
